import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { routerReducer } from "react-router-redux";
import { reducer as flashReducer } from "redux-flash";

import loginReducer from "../pages/login/reducer";
import signupReducer from "../pages/signup/reducer";
import addCardReducer from "../pages/subscription/reducer";
import passwordRecoveryReducer from "../pages/password-recovery/reducer";
import passwordResetReducer from "../pages/password-reset/reducer";
import passwordChangeReducer from "../pages/password-change/reducer";
import completeSubscriptionReducer from "../pages/complete-subscription/reducer";
import adminReducer from "../pages/admin/reducer";
import playlistsReducer from "../pages/playlists/reducer";
import addPlaylistReducer from "../pages/playlists/add/reducer";
import updatePlaylistReducer from "../pages/playlists/update/reducer";
import planningsReducer from "../pages/plannings/reducer";
import videosReducer from "../pages/playlists/form/videos/reducer";
import videoChooserReducer from "../pages/playlists/form/videos/video-chooser/reducer";
import Patientplaylist from "../pages/patientplaylist/reducer";
import videosPlaylist from "../pages/patientplaylist/reducer";
import GoogleMap from "../pages/patientplaylist/reducer";
import ConfirmEmail from "../pages/confirmemail/reducer";
import { LOGOUT_SUCCESS } from "../pages/login/actions";
import updateProfileReducer from "../pages/userprofile/reducer";
import invoicesReducer from "../pages/userinvoices/reducer";
import QrCodeReducer from "../pages/patientplaylist/reducer";
import GoogleMapReact from "google-map-react";
import nbVisitedWebSite from "../pages/admin/stats/reducer";
import top3Categ from "../pages/admin/stats/reducer";
import arrayVisiteYears from "../pages/admin/stats/reducer";

const appReducer = combineReducers({
  form: formReducer,
  router: routerReducer,
  flash: flashReducer,
  login: loginReducer,
  signup: signupReducer,
  addCard: addCardReducer,
  "update-profile": updateProfileReducer,
  "password-recovery": passwordRecoveryReducer,
  "password-reset": passwordResetReducer,
  "password-change": passwordChangeReducer,
  "complete-subscription": completeSubscriptionReducer,
  admin: adminReducer,
  "email-varification": ConfirmEmail,
  playlists: playlistsReducer,
  "add-playlist": addPlaylistReducer,
  "update-playlist": updatePlaylistReducer,
  plannings: planningsReducer,
  videos: videosReducer,
  "video-chooser": videoChooserReducer,
  "video-patient": Patientplaylist,
  "playlist-videos": videosPlaylist,
  "google-map": GoogleMap,
  invoices: invoicesReducer,
  numberVisite: QrCodeReducer,
  nbVisite: nbVisitedWebSite,
  top3Categ: top3Categ,
  arrayVisiteYears: arrayVisiteYears,
});

const reducers = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers.js